module.exports = __webpack_public_path__ + "static/media/invite_phone_m.9f6aa2dd.png";